import {
    GETROLEDROPLIST_SUCCESS,
    GETROLEDROPLIST_FAILED,
    RESET_GETROLEDROPLIST,
    LOADING_GETROLEDROPLIST,
    NETWORK_ERROR_GETROLEDROPLIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";


const resetGetRoleDropList = () => {
    return { type: RESET_GETROLEDROPLIST };
};

const getRoleDropLists = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETROLEDROPLIST });
    await partnerServices
        .post("getRoleDropList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(getRoleDropListsuccess(res.data));
                    break;
                default:
                    dispatch(getRoleDropListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({ type: NETWORK_ERROR_GETROLEDROPLIST, payload: err });
        });
};
function getRoleDropListsuccess(data) {
    return {
        type: GETROLEDROPLIST_SUCCESS,
        payload: data,
    };
}
function getRoleDropListFailed(data) {
    return {
        type: GETROLEDROPLIST_FAILED,
        payload: data,
    };
}

export { resetGetRoleDropList, getRoleDropLists };
